<template>
  <div class="container">
    <div class="columns box-title is-12">
      <div class="column is-6">
        <h4 class="has-text-left">
          <i class="fal fa-gifts"></i>
          ສະຫຼຸບຍອດສາຂາທັງໝົດ
        </h4>
      </div>
    </div>

    <div class="box">
      <div class="columns is-multiline is-mobile filter-section">
        <div class="column is-6-mobile is-3-tablet is-2-desktop">
          <div class="control">
            <label class="label">ຈາກວັນທີ:</label>
            <date-picker
                format="DD/MM/YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                v-model="start_date"
                :disabled-date="disabledAfterToday"
                :clearable="false"
                name="start_date"
            ></date-picker>
          </div>
        </div>
        <div class="column is-6-mobile is-3-tablet is-2-desktop">
          <div class="control">
            <label class="label">ຫາວັນທີ:</label>
            <date-picker
                format="DD/MM/YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                v-model="end_date"
                :disabled-date="disabledAfterToday"
                :clearable="false"
                name="end_date"
            ></date-picker>
          </div>
        </div>
        <div class="column is-12-mobile is-2-tablet is-2-desktop">
          <div class="field">
            <div class="control">
              <label class="label is-hidden-mobile">&nbsp;</label>
              <vs-button
                  ref="button" flat
                  @click="FetchData()"
                  class="form-btn-loading"
                  :loading="loading">
                ຄົ້ນຫາ
              </vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="summary-cards" v-if="hasSummaryData">
      <div class="columns is-multiline">
        <div class="column is-12-mobile is-4-tablet is-2-desktop">
          <div class="summary-card">
            <div class="card-label">ຍອດສ້າງບິນຕົ້ນທາງ</div>
            <div class="card-value">{{ FormatPrice(listSummary.receiveOriginQty) }} <span class="unit">ບິນ</span></div>
            <div class="card-sub">{{ FormatPrice(listSummary.receiveOriginFreight) }} <span class="unit">ກີບ</span></div>
          </div>
        </div>
        <div class="column is-12-mobile is-4-tablet is-2-desktop">
          <div class="summary-card">
            <div class="card-label">ຍອດສ້າງບິນ CDC</div>
            <div class="card-value">{{ FormatPrice(listSummary.receiveCdcQty) }} <span class="unit">ບິນ</span></div>
            <div class="card-sub">{{ FormatPrice(listSummary.receiveCdcFreight) }} <span class="unit">ກີບ</span></div>
          </div>
        </div>
        <div class="column is-12-mobile is-4-tablet is-2-desktop">
          <div class="summary-card">
            <div class="card-label">ຍອດສ້າງບິນ COD</div>
            <div class="card-value">{{ FormatPrice(listSummary.receiveCodQty) }} <span class="unit">ບິນ</span></div>
            <div class="card-sub">{{ FormatPrice(listSummary.receiveCodFreight) }} <span class="unit">ກີບ</span></div>
          </div>
        </div>
        <div class="column is-12-mobile is-4-tablet is-2-desktop">
          <div class="summary-card">
            <div class="card-label">ຍອດສ້າງບິນປາຍທາງທີ່ສຳເລັດ</div>
            <div class="card-value">{{ FormatPrice(listSummary.receiveCdcSuccessQty) }} <span class="unit">ບິນ</span></div>
            <div class="card-sub">{{ FormatPrice(listSummary.receiveCdcSuccessFreight) }} <span class="unit">ກີບ</span></div>
          </div>
        </div>
        <div class="column is-12-mobile is-4-tablet is-2-desktop">
          <div class="summary-card">
            <div class="card-label">ຍອດຈັດສົ່ງບິນຕົ້ນທາງ</div>
            <div class="card-value">{{ FormatPrice(listSummary.successOriginQty) }} <span class="unit">ບິນ</span></div>
            <div class="card-sub">{{ FormatPrice(listSummary.successOriginFreight) }} <span class="unit">ກີບ</span></div>
          </div>
        </div>
        <div class="column is-12-mobile is-4-tablet is-2-desktop">
          <div class="summary-card">
            <div class="card-label">ຍອດຈັດສົ່ງບິນ CDC</div>
            <div class="card-value">{{ FormatPrice(listSummary.successCdcQty) }} <span class="unit">ບິນ</span></div>
            <div class="card-sub">{{ FormatPrice(listSummary.successCdcFreight) }} <span class="unit">ກີບ</span></div>
          </div>
        </div>
        <div class="column is-12-mobile is-4-tablet is-2-desktop">
          <div class="summary-card">
            <div class="card-label">ຍອດຈັດສົ່ງບິນ COD</div>
            <div class="card-value">{{ FormatPrice(listSummary.successCodQty) }} <span class="unit">ບິນ</span></div>
            <div class="card-sub">{{ FormatPrice(listSummary.successCodFreight) }} <span class="unit">ກີບ</span></div>
          </div>
        </div>
      </div>
    </div>

    <Loading v-if="isLoading"/>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import Loading from "@/views/Loading";
import DatePicker from "vue2-datepicker";
import moment from "moment";

export default {
  components: {
    DatePicker,
    Loading
  },

  data: () => ({
    start_date: moment(new Date()).format('YYYY-MM-DD'),
    end_date: moment(new Date()).format('YYYY-MM-DD'),
    isLoading: false,
    listSummary: [],
    loading: false,
  }),

  computed: {
    hasSummaryData() {
      return this.listSummary && Object.keys(this.listSummary).length > 0 && !Array.isArray(this.listSummary);
    }
  },

  methods: {
    FormatPrice(price) {
      if (price < 1 && price >= 0) {
        return price;
      }
      let p = (parseInt(price) || 0).toFixed(2).split(".");
      return p[0].split("").reverse().reduce(function (acc, price, i) {
        return price === "-" ? acc : price + (i && !(i % 3) ? "," : "") + acc;
      }, "");
    },

    disabledAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    },

    FetchData() {
      this.loading = true;
      this.$http.get('branch/shipment/total', {
        params: {
          start_date: this.start_date,
          end_date: this.end_date,
        }
      }).then((res) => {
        setTimeout(() => {
          this.listSummary = res.data;
          this.loading = false;
        }, 300);
      }).catch(() => {
        this.loading = false;
      });
    },

    ...mapActions({
      LogoutUser: "User/destroyToken",
    }),

    BtnLoading() {
      return this.$vs.loading({
        target: this.$refs.table,
        scale: "1",
        background: "primary",
        opacity: 1,
        color: "#195BFF",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  margin-top: 40px;
}

.filter-section {
  align-items: flex-end;
}

.summary-cards {
  margin-top: 10px;

  .summary-card {
    background: #fff;
    border-radius: 10px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    text-align: center;
    height: 100%;

    .card-label {
      font-size: 13px;
      color: #666;
      margin-bottom: 8px;
      font-weight: 500;
    }

    .card-value {
      font-size: 20px;
      font-weight: 700;
      color: #195BFF;
    }

    .card-sub {
      font-size: 14px;
      font-weight: 600;
      color: #333;
      margin-top: 4px;
    }

    .unit {
      font-size: 12px;
      font-weight: 400;
      color: #999;
    }
  }
}

@media screen and (max-width: 768px) {
  .summary-card {
    margin-bottom: 8px;

    .card-value {
      font-size: 18px !important;
    }

    .card-sub {
      font-size: 13px !important;
    }
  }
}
</style>
